import styled from 'styled-components';

import { Box } from 'components/library';

export const StyledWrapper = styled(Box)`
  label {
    font-weight: 700;
  }

  > * {
    ${({ $mb }) => Boolean($mb) && `margin-bottom: ${$mb}px;`};
  }
`;
